<template>
  <div class="screen-item">
    <div class="title-area">
      <span class="title-mark"></span>
      <span class="title-text">{{ title }}</span>
      <span class="title-line"></span>
      <span class="title-chevrons">›››</span>
    </div>
    <div class="content-area">
      <slot></slot>
    </div>
    <i class="corner-bl"></i>
    <i class="corner-br"></i>
  </div>
</template>

<script>
export default {
  name: "homeItem",
  props: {
    title: String,
  },
};
</script>

<style scoped lang="scss">
@import "../aftersaleOverview/css/screen-theme.scss";

.screen-item {
  @include screen-tech-frame;
  @include screen-tech-corners-bottom;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.title-area {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px 8px;
  background: $screen-header-bar;
  box-sizing: border-box;
}

.title-mark {
  @include screen-title-mark;
}

.title-text {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: $screen-text;
  letter-spacing: 2px;
  text-shadow: 0 0 10px rgba(0, 229, 255, 0.55);
}

.title-line {
  flex: 1;
  height: 1px;
  min-width: 24px;
  background: linear-gradient(
    90deg,
    rgba(0, 229, 255, 0.55),
    rgba(0, 229, 255, 0.12),
    transparent
  );
}

.title-chevrons {
  flex-shrink: 0;
  font-size: 11px;
  letter-spacing: -2px;
  color: rgba(0, 229, 255, 0.55);
  line-height: 1;
}

.content-area {
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: stretch;
  overflow: hidden;
  padding: 6px 10px 8px;
  box-sizing: border-box;

  /* 让 TOP5 这类内容拿到确定高度 */
  > * {
    flex: 1;
    width: 100%;
    min-height: 0;
    height: 100%;
  }
}
</style>
